(ns com.theplantscape.plant-web.draw.events
  (:require
   [com.theplantscape.local-store.ensemble
    :refer [add-new-diagram-object
            fetch-plant
            nearest-point
            reset
            rm-entity
            update-entity]]
   [com.theplantscape.calculate.ensemble :refer [snap-grid]]
   [com.theplantscape.plant-web.draw.helpers :refer [get-millis]]
   [com.theplantscape.plant-web.draw.points :refer [points-close?]]
   [com.theplantscape.plant-web.draw.state
    :refer
    [app-state
     move-canvas
     reset-mouse
     reset-pointer
     reset-selection
     tools]]))

(defn screen-to-point-xy
  "get svg cordinate, svg element must have the svg namespace to work
  also to handled translated elements, call the matrix transform on on the translated
  child (likely a [:g] element) not the svg node."
  [svg-target svg-transformed size width xy]
  (when svg-target
    (let [stone-width (/ width size)
          svg-point (.createSVGPoint svg-target)]
      (set! (.-x svg-point) (first xy))
      (set! (.-y svg-point) (second xy))
      (let [transformed (->> svg-transformed
                             .getScreenCTM
                             .inverse
                             (.matrixTransform svg-point))]
        (snap-grid [(.-x transformed)  (.-y transformed)] 0.1 true)))))

(defn point-to-screen-xy
  "Inverse of above to translate cordinates back, basically don't do the inverse"
  [svg-target svg-transformed size width xy]
  (when svg-target
    (let [stone-width (/ width size)
          svg-point (.createSVGPoint svg-target)]
      (set! (.-x svg-point) (first xy))
      (set! (.-y svg-point) (second xy))
      (let [transformed (->> svg-transformed
                             .getScreenCTM
                             (.matrixTransform svg-point))]
        [(.-x transformed) (.-y transformed)]))))

#_(point-to-screen-xy
   (js/document.getElementById "events")
   (js/document.getElementById "events-transform")
   400
   400
   [-627 -587])

#_(screen-to-point-xy
   (js/document.getElementById "events")
   (js/document.getElementById "events-transform")
   400
   400
   [10 10])

;; https://www.sitepoint.com/how-to-translate-from-dom-to-svg-coordinates-and-back-again/
#_(defn screen-to-point
    "get svg cordinate, svg element must have the svg namespace to work
  also to handled translated elements, call the matrix transform on on the translated
  child (likely a [:g] element) not the svg node."
    ([evt size width] (screen-to-point evt (.-target evt) size width))
    ([evt svg-target size width]
     (when svg-target
       (let [stone-width (/ width size)
             t (fn [x] (.floor js/Math (/ x stone-width)))
             ^js svg svg-target
             ^js svg-node (js/document.getElementById "events-transform")
             p (.createSVGPoint svg)]
         (set! (.-x p) (.-clientX evt))
         (set! (.-y p) (.-clientY evt))
         (let [transformed (->> svg-node
                                .getScreenCTM
                                .inverse
                                (.matrixTransform p))]
           [(t (.-x transformed)) (t (.-y transformed))])))))

(defn make-coords-xy-r
  ([[x y]] (make-coords-xy-r x y))
  ([x y]
   (point-to-screen-xy
    (js/document.getElementById "events")
    (js/document.getElementById "events-transform")
    (-> @app-state :canvas :width)
    (-> @app-state :canvas :height)
    [x y])))

(defn ref-make-coords-xy
  ([root-svg-element transformed-svg-element [x y]] (ref-make-coords-xy root-svg-element transformed-svg-element x y))
  ([root-svg-element transformed-svg-element x y]
   (screen-to-point-xy
    root-svg-element
    transformed-svg-element
    (-> @app-state :canvas :width)
    (-> @app-state :canvas :height)
    [x y])))

(defn make-coords-xy
  ([[x y]] (make-coords-xy x y))
  ([x y]
   (screen-to-point-xy
    (js/document.getElementById "events")
    (js/document.getElementById "events-transform")
    (-> @app-state :canvas :width)
    (-> @app-state :canvas :height)
    [x y])))

(defn make-coords [evt]
  (screen-to-point-xy
   (js/document.getElementById "events")
   (js/document.getElementById "events-transform")
   (-> @app-state :canvas :width)
   (-> @app-state :canvas :height)
   [(.-clientX evt) (.-clientY evt)])
  ;(screen-to-point evt (js/document.getElementById "events") 400 400)
  #_(screen-to-point evt 400 400))

(defn reset-state []
  (reset-mouse)
  (reset))

(defn register-global-keyup [type callback]
  (.addEventListener js/document "keyup" callback))

(defn register-global-keypress [type callback]
  (.addEventListener js/document type callback))

(defn key-arrow [evt callback]
  (.preventDefault evt)
  (case (.-key evt)
    "ArrowLeft" (callback [1 0])
    "ArrowRight" (callback [-1 0])
    "ArrowUp" (callback [0 1])
    "ArrowDown" (callback [0 -1])))

(defn key-press [key evt callback]
  (.preventDefault evt)
  (if (vector? key)
    (when (some #(= % (.-key evt)) key)
      (callback))
    (when (= key (.-key evt))
      (callback))))

(def key-escape (partial key-press ["Escape" "Esc"]))

(defn key-enter [evt callback]
  (.preventDefault evt)
  (when (= "Enter" (.-key evt))
    (callback)))

(defn plural-keyword [k]
  (keyword (str (name k) "s")))

(defn rm-ob [entity-id]
  (when entity-id
    (reset-selection)
    (rm-entity entity-id)))

(defn move-ob
  ([xy]

   (when (-> @app-state :selected :eid)
     (move-ob (-> @app-state :selected :eid) :diagram.object/position xy)))
  ([attribute xy]
   (when (-> @app-state :selected :eid)
     (move-ob (-> @app-state :selected :eid) attribute xy)))
  ([eid attribute xy]
   (prn (str "move selected " eid))
   (prn (assoc
         (vec (-> @app-state :selected :object attribute))
         (-> @app-state :selected :index)
         xy))
   ;; (prn attribute)
   ;; (prn xy)
   (update-entity
    eid
    attribute
    (assoc
     (vec (-> @app-state :selected :object attribute))
     (-> @app-state :selected :index)
     xy))))

(defn select-ob-by-entity
  [entity-id]
  (when-let [plant (fetch-plant entity-id)]
    (apply move-canvas [(* -1 (-> plant :diagram.object/position first first))
                        (* -1 (-> plant :diagram.object/position first second))]))
  (swap! app-state assoc :selected {:eid entity-id
                                    ;; :index (-> object second first)
                                    :object (fetch-plant entity-id)}))

(defn select-ob-from-point
  "Determine which element the user clicked on by working out closest point"
  ([xy] (select-ob-from-point :diagram.object/position xy))
  ([attribute xy]
   (prn "select ob from point")
   (prn (nearest-point attribute xy))
   (when-let [object (nearest-point attribute xy)]
     (let [p (fetch-plant (first object))
           translated-point (make-coords-xy-r (-> p attribute first))]
       (let [tp  (-> p attribute first)
             x0  (-> p attribute first first)
             y0  (-> p attribute first second)]

         (apply move-canvas [(* -1 x0) (* -1 y0)] #_(-> p :diagram.object/position first)))
       (-> @app-state :selected )
       (prn (str "set selected object " (first object)))
       ;; TODO need to translate to make this work
       ;;(apply move-canvas translated-point #_(-> p :diagram.object/position first))
       (swap! app-state assoc :selected {:eid (first object)
                                         :index (-> object second first)
                                         :object p})
       (prn "selected")
       (-> @app-state :selected prn)
       ))))

(defn select-remove-ob [evt]
  (select-ob-from-point evt)
  (rm-ob (-> @app-state :selected :eid)))

(defn start-drag [evt]
  (let [rect (.getBoundingClientRect (.-target evt))]
    (swap! app-state assoc :selected (.-target evt))
    #_(swap! app-state update (plural-keyword (:tool @app-state))  conj
             [(- (.-clientX evt) (.-x rect))
              (- (.-clientY evt) (.-y rect))])))

(defn mouse-down [evt]
  (reset-mouse))

(defn mouse-up [evt]
  (reset-mouse))

#_(defn handle-mouse-down [xy complete-callback store-callback]
  ;; if history is greater than 1 and distance is close then complete
  ;; multi should have more than 1 points to complete
    (if (and (> (count (-> @app-state :mouse :history)) 1)
             (points-close? xy (-> @app-state :mouse :history first)))
      (complete-callback)
      (store-callback xy)))

(defn store-mouse-coords [xy]
  (swap! app-state assoc-in [:mouse :button :pos] xy)
  (swap! app-state assoc-in [:mouse :dragging] nil)
  (swap! app-state assoc-in [:mouse :start-time] (get-millis))
  (swap! app-state update-in [:mouse :history] #(conj % xy)))

(defn mouse
  ([type evt] (mouse type evt identity))
  ([type evt fn-callback]
   (let [xy (make-coords evt)]
     (swap! app-state assoc-in [:mouse :pos] xy)
     (case type
       :up (do (swap! app-state assoc-in [:mouse :button :state] nil)
               (swap! app-state assoc-in [:mouse :button :dragging] nil))
       :down (do
               (swap! app-state assoc-in [:mouse :button]
                      {:state :down :dragging nil :pos [0 0] :elapsed 0 :time (get-millis)}))

       :move (do
               (swap! app-state assoc-in [:mouse :button :pos] xy)

               ;; change how history is inserted
               (if (empty? (-> @app-state :mouse :history))
                 (swap! app-state update-in [:mouse :history] #(conj % xy))
                 (swap! app-state update-in [:mouse :history] #(conj (pop %) (make-coords evt))))

               (when (= :down (-> @app-state :mouse :button :state))
                 (swap! app-state assoc-in [:mouse :button :elapsed]
                        (- (get-millis) (-> @app-state :mouse :button :time)))
                 (when (> (- (get-millis) (-> @app-state :mouse :button :time)) 300)
                   (swap! app-state assoc-in [:mouse :button :dragging] true)))))
     (fn-callback xy))))

(defn mouse-coords [evt]
  (when (= :down (-> @app-state :mouse :button :state))
    (when (> (- (get-millis) (-> @app-state :mouse :start-time)) 300)
      (swap! app-state assoc-in [:canvas :pos] (map - (-> @app-state :mouse :button :pos) (make-coords evt)))
      (swap! app-state assoc-in [:mouse :dragging] true)))

  (if (empty? (-> @app-state :mouse :history))
    (store-mouse-coords (make-coords evt))
    (swap! app-state update-in [:mouse :history] #(conj (pop %) (make-coords evt))))
  (swap! app-state assoc-in [:mouse :pos] (make-coords evt)))

#_(defn create-ob [evt type]
    (prn "create")
    (prn evt)
    (prn type)
    (when (= true (-> @app-state :mouse :multi))
      (case type
        :path
        (add-new-diagram-object type (-> @app-state :mouse :history))
        (add-new-diagram-object type (-> @app-state :mouse :pos))))
    (reset-mouse))

(defn mouse-history-last []
  (-> @app-state :mouse :history last))

(defn mouse-history []
  (-> @app-state :mouse :history))

(defn mouse-pos []
  (-> @app-state :mouse :pos))

(defn mouse-history-drop-last []
  (drop-last (-> @app-state :mouse :history)))

(defn set-tool
  [tool]
  (prn "set tool " tool)
  (when tool
    (swap! app-state assoc-in [:mouse :tool] tool)
    (swap! app-state assoc-in [:mouse :multi] (or (-> tools tool :multi) false))
    (swap! app-state assoc :tool tool)))

(defn check-vals [hm keys]
  (when (not (every? (fn [[_ v]] (some? v)) (select-keys hm keys)))
    (prn (str "Missing value " keys)))
  (every? (fn [[_ v]] (some? v)) (select-keys hm keys)))

(defn create-shape [type xy]
  (prn (str "create shape " type))
  (prn (-> @app-state :current))
  (prn (-> @app-state :current :plant))
  (check-vals (-> @app-state :current :plant) [:id :uuid :type])
  (let [plant-info (when (-> @app-state :current :plant)
                     {:diagram.object/plant-entity-id (-> @app-state :current :plant :db/id)
                      :diagram.object/plant-uuid (-> @app-state :current :plant :plant/id)
                      :diagram.object/svg-filter (-> @app-state :current :plant :plant/type name)})]
    (prn "create-shape")
    (prn plant-info)
    (case type
      :patch (add-new-diagram-object
              type (mouse-history)
              plant-info)
      :path (add-new-diagram-object type (mouse-history))
      :structure (add-new-diagram-object type  (mouse-history))
      :area (add-new-diagram-object type  (mouse-history))
      (add-new-diagram-object type [xy] plant-info)))
  (reset-pointer)
  (reset-mouse))

(defn create-shape-multi-point
  [type xy]
  (prn "########")
  (prn type)
  (prn xy)
  (when type
    (if (-> tools type :multi)
      (when (and (> (count (-> @app-state :mouse :history)) 1)
                 (points-close? xy
                                (-> @app-state :mouse :history first)
                                (-> @app-state :canvas :scale :distance)))
        (create-shape type xy))
      (create-shape type xy))))

(comment  (-> @app-state :current :plant)
          (create-shape :path [[10 10] [20 20] [30 50]]))
